var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('vue-chartist',{staticClass:"height-200 ct-hidden-points",attrs:{"type":"Line","data":_vm.data,"options":_vm.options}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-body"},[_c('div',{staticClass:"font-weight-bold font-size-36 font-weight-bold text-success"},[_vm._v("12,255Gb")])])
}]

export { render, staticRenderFns }